(function() {
  const STORAGE_KEY = 'creopack_saved_products';

  function getSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function setSaved(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('creopack:wishlist-updated', { detail: { items } }));
  }

  function updateCount() {
    const count = getSaved().length;
    document.querySelectorAll('[data-cp-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function isSaved(handle, variantId) {
    return getSaved().some(item => item.handle === handle && String(item.variant_id || '') === String(variantId || ''));
  }

  function toggleProduct(payload) {
    const items = getSaved();
    const index = items.findIndex(item =>
      item.handle === payload.handle &&
      String(item.variant_id || '') === String(payload.variant_id || '')
    );

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(payload);
    }

    setSaved(items);
    updateCount();
    syncButtons();
  }

  function syncButtons() {
    document.querySelectorAll('[data-cp-wishlist-toggle]').forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      const variantId = btn.getAttribute('data-variant-id') || '';
      const active = isSaved(handle, variantId);
      btn.classList.toggle('is-saved', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-cp-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault();

    toggleProduct({
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      image: btn.getAttribute('data-image') || '',
      variant_id: btn.getAttribute('data-variant-id') || '',
      variant_title: btn.getAttribute('data-variant-title') || '',
      price: btn.getAttribute('data-price') || '',
      meta: btn.getAttribute('data-meta') || ''
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    updateCount();
    syncButtons();
  });

  window.addEventListener('creopack:wishlist-updated', function() {
    updateCount();
    syncButtons();
  });

  window.CreopackWishlist = {
    getSaved,
    setSaved,
    updateCount,
    syncButtons
  };
})();